import React, { useReducer, useState } from 'react'
import './cal.css'
import DigitButton from './DigitButton'
import { reducer } from './reducer'
import OperationButton from './OperationButton'

export const ACTIONS = {
    ADD_DIGIT: 'add-digit',
    CHOOSE_OPERATION: "choose-operation",
    CLEAR: 'clear',
    DELETE_DIGIT: "delete-digit",
    EVUALATE: "evaulate"

}

const Calculator = () => {

    const [{
        currentOperand,
        previousOperand,
        operation,
        overwrite
    }, dispatch] = useReducer(reducer, {});

    return (
        <div className="container">
            <div className="calculator-grid">
                <div className="output">
                    <div className="previous-operand">{previousOperand} {operation} </div>
                    <div className="current-operand">{currentOperand} </div>
                </div>

                <button className='span-two' onClick={() => { dispatch({ type: ACTIONS.CLEAR }) }}>AC</button>
                <button onClick={() => dispatch({ type: ACTIONS.DELETE_DIGIT })}>DEL</button>
                <OperationButton operation="/" dispatch={dispatch}></OperationButton>

                {/* <OperationButton operation="sin" dispatch={dispatch}></OperationButton> */}

                <DigitButton digit="1" dispatch={dispatch}></DigitButton>
                <DigitButton digit="2" dispatch={dispatch}></DigitButton>
                <DigitButton digit="3" dispatch={dispatch}></DigitButton>

                <OperationButton operation="*" dispatch={dispatch}></OperationButton>
                {/* <OperationButton operation="cos" dispatch={dispatch}></OperationButton> */}

                <DigitButton digit="4" dispatch={dispatch}></DigitButton>
                <DigitButton digit="5" dispatch={dispatch}></DigitButton>
                <DigitButton digit="6" dispatch={dispatch}></DigitButton>

                <OperationButton operation="+" dispatch={dispatch}></OperationButton>
                {/* <OperationButton operation="tan" dispatch={dispatch}></OperationButton> */}

                <DigitButton digit="7" dispatch={dispatch}></DigitButton>
                <DigitButton digit="8" dispatch={dispatch}></DigitButton>
                <DigitButton digit="9" dispatch={dispatch}></DigitButton>

                <OperationButton operation="-" dispatch={dispatch}></OperationButton>
                {/* <OperationButton operation="cosine" dispatch={dispatch}></OperationButton> */}

                <DigitButton digit="." dispatch={dispatch}></DigitButton>
                <DigitButton digit="0" dispatch={dispatch}></DigitButton>
             


                <button
                    onClick={() => { dispatch({ type: ACTIONS.EVUALATE }) }}
                >=</button>

                <OperationButton operation="%" dispatch={dispatch}></OperationButton>

                {/* <OperationButton operation="sec" dispatch={dispatch}></OperationButton> */}
            </div>
        </div>

    )
}

export default Calculator